import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
// CSS order matters: base layers first, then the placeholder Porcelain vars,
// then the shared tokens package (virtual:nmach-tokens.css) so its values
// win once packages/tokens/tokens.css lands (TODO-reconcile).
import './styles/index.css'
import './styles/theme.css'
import 'virtual:nmach-tokens.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
